import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

export enum SUBSCRIPTION_MODAL_MODE {
    SUBSCRIBE = 'subscribe',
    UNSUBSCRIBE = 'unsubscribe',
}

export interface OpenModalAction {
    opened: true;
    mode: SUBSCRIPTION_MODAL_MODE;
}
export interface CloseModalAction {
    opened: false;
}
export type ToggleModalAction = OpenModalAction | CloseModalAction;

export const isOpenModalAction = (value: ToggleModalAction): value is OpenModalAction => {
    return value.hasOwnProperty('mode');
};

export interface SubscriptionModalStore {
    opened: boolean;
    mode: SUBSCRIPTION_MODAL_MODE;
    loadingStatuses: Record<string, LOADING_STATUSES>;
}
